import { NgModule } from '@angular/core';
import { GroupManagerComponent } from './groupManager.component';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralModule } from '../general/general.module';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GroupListComponent } from './groupList.component';
import { GroupCreateComponent } from './groupCreate.component';
import { GroupEditorBasicComponent } from './groupEditorBasic.component';
import { GroupEditComponent } from './groupEdit.component';
import { GroupMembersComponent } from './groupMembers.component';
import { GroupTopicsComponent } from './groupTopics.component';
import { SelectMultipleUsersDialogComponent } from './selectMultipleUsersDialog.component';
import { SelectMultipleTopicsDialogComponent } from './selectMultipleTopicsDialog.component';
import { GroupBriefingsComponent } from './groupBriefings.component';
import { SelectMultipleBriefingsDialogComponent } from './selectMultipleBriefingsDialog.component';

@NgModule({
    imports: [
        CommonModule,
        DirectivesModule,
        FlexLayoutModule,
        FormsModule,
        GeneralModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    declarations: [
        GroupBriefingsComponent,
        GroupCreateComponent,
        GroupEditComponent,
        GroupEditorBasicComponent,
        GroupListComponent,
        GroupManagerComponent,
        GroupMembersComponent,
        GroupTopicsComponent,
        SelectMultipleBriefingsDialogComponent,
        SelectMultipleUsersDialogComponent,
        SelectMultipleTopicsDialogComponent
    ],
    exports: [
        GroupCreateComponent,
        GroupEditComponent,
        GroupListComponent,
        GroupManagerComponent,
        GroupMembersComponent,
        GroupTopicsComponent
    ],
    entryComponents: [
        SelectMultipleUsersDialogComponent,
        SelectMultipleTopicsDialogComponent
    ]
})
export class GroupsModule {
}